export default "__VITE_ASSET__BkNeGW9b__"